document.addEventListener('DOMContentLoaded', function() {
  // Function to calculate and display savings
  function displaySavings(priceContainer) {
    // Try different selectors for different page types
    let salePriceElement, regularPriceElement;
    
    // Check for grid product card structure
    salePriceElement = priceContainer.querySelector('.m-price__sale .m-price-item--sale');
    regularPriceElement = priceContainer.querySelector('.m-price__sale s.m-price-item--regular');
    
    // If not found, check for individual product page structure
    if (!salePriceElement || !regularPriceElement) {
      salePriceElement = priceContainer.querySelector('.m-price-item--sale.m-price-item--last');
      regularPriceElement = priceContainer.querySelector('.m-price__sale s.m-price-item--regular');
    }
    
    if (salePriceElement && regularPriceElement) {
      // Extract numeric values
      const saleText = salePriceElement.textContent || salePriceElement.getAttribute('data-amount') || salePriceElement.getAttribute('data-usd');
      const regularText = regularPriceElement.textContent;
      
      const salePrice = parseFloat(saleText.replace(/[^0-9.]/g, ''));
      const regularPrice = parseFloat(regularText.replace(/[^0-9.]/g, ''));
      
      const difference = regularPrice - salePrice;
        const percentOff = Math.round((difference / regularPrice) * 100);

    // Only proceed if there's an actual discount
    if (difference > 0 && percentOff > 0) {
    // Check if savings element already exists
    const existingSave = priceContainer.querySelector('.m-price__save');
    if (existingSave) {
        existingSave.textContent = `${percentOff}% off`;
        return;
    }

  // Create savings element
  const saveElement = document.createElement('span');
  saveElement.className = 'm-price__save';
  saveElement.textContent = `${percentOff}% off`;

        
        // Add appropriate styling based on page type
        if (priceContainer.closest('.main-product__block-price')) {
          // Individual product page styling
          saveElement.style.marginLeft = '10px';
          saveElement.style.color = '#ffffff';
          saveElement.style.fontSize = '1rem';
          saveElement.style.backgroundColor = '#2B8282';
          saveElement.style.padding = '4px 8px';
          saveElement.style.borderRadius = '20px';
        } else {
          // Grid product card styling
          saveElement.style.marginLeft = '5px';
          saveElement.style.color = '#ffffff';
          saveElement.style.fontSize = '0.9em';
          saveElement.style.backgroundColor = '#2B8282';
          saveElement.style.padding = '4px 8px';
          saveElement.style.borderRadius = '20px';
        }
        
        // Insert after the strikethrough price
        regularPriceElement.parentNode.insertBefore(saveElement, regularPriceElement.nextSibling);
      }
    }
  }

  // Process all price containers on the page
  function processAllPriceContainers() {
    // Individual product page container
    const mainProductPrice = document.querySelector('.main-product__block-price');
    if (mainProductPrice) {
      displaySavings(mainProductPrice);
    }
    
    // Grid product cards
    const productCards = document.querySelectorAll('.m-product-card');
    productCards.forEach(card => {
      const priceContainer = card.querySelector('.m-product-card__price');
      if (priceContainer) {
        displaySavings(priceContainer);
      }
    });
  }

  
  // Initial processing
processAllPriceContainers();

// --- Observe price changes when variants are switched ---
const mainPriceBlock = document.querySelector('.main-product__block-price');

if (mainPriceBlock) {
  const priceObserver = new MutationObserver(() => {
    // Temporarily stop observing to avoid loop
    priceObserver.disconnect();

    // Recalculate savings for updated price
    displaySavings(mainPriceBlock);

    // Reconnect after small delay to let DOM settle
    setTimeout(() => {
      priceObserver.observe(mainPriceBlock, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }, 300);
  });

  // Start observing price text changes
  priceObserver.observe(mainPriceBlock, {
    childList: true,
    subtree: true,
    characterData: true
  });
}


  // For dynamic loading (like infinite scroll or variant changes), use MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          // Check if this is a new product card
          if (node.classList && node.classList.contains('m-product-card')) {
            const priceContainer = node.querySelector('.m-product-card__price');
            if (priceContainer) displaySavings(priceContainer);
          }
          // Check if this is the main product price block
          else if (node.classList && node.classList.contains('main-product__block-price')) {
            displaySavings(node);
          }
          // Otherwise check for price containers within the node
          else {
            const priceContainers = node.querySelectorAll('.main-product__block-price, .m-product-card__price');
            priceContainers.forEach(displaySavings);
          }
        }
      });
    });
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});